import { render, staticRenderFns } from "./PatientCovProgramInfo.vue?vue&type=template&id=23eac405"
import script from "./PatientCovProgramInfo.vue?vue&type=script&lang=js"
export * from "./PatientCovProgramInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports